import { render, staticRenderFns } from "./DsfrTranscription.vue?vue&type=template&id=661bd6bc&"
import script from "./DsfrTranscription.vue?vue&type=script&lang=js&"
export * from "./DsfrTranscription.vue?vue&type=script&lang=js&"
import style0 from "./DsfrTranscription.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports